import React from "react";
import {
  Flex,
  PageContent,
  PageHeadingArea,
  PageTitle,
  ResponsiveLayoutWrapper,
  Root,
} from "@backslashbuild/contractors-ui-library";

import NavBar from "../components/NavBar";
import ContractorTopBar from "../modules/contractors/ContractorTopBar";
import ContractorEditBankDetails from "../modules/contractors/ContractorEditBankDetails";
import AcceptContractDialog from "../modules/contractors/AcceptContractDialog";
import PageFooter from "../components/PageFooter";

function EditBankDetails() {
  return (
    <Root>
      <PageContent scrollable>
        <ContractorTopBar />
        <NavBar />
        <PageHeadingArea>
          <PageTitle>Edit bank details</PageTitle>
        </PageHeadingArea>
        <ResponsiveLayoutWrapper>
          <ContractorEditBankDetails />
        </ResponsiveLayoutWrapper>
        <Flex></Flex>
        <PageFooter />
        <AcceptContractDialog />
      </PageContent>
    </Root>
  );
}

export default EditBankDetails;
